export default {
  //batch list
  batches: [],
  loading: false,
  total: 0,
  FilteredCount: 0,
  batch: null,
  batchPlantGroupByName: [],

  //plants list
  'plant-plants': [],
  'plant-loading': false,
  'plant-total': 0,
  'plant-FilteredCount': 0,

  //archive plants list
  'archived-plant-plants': [],
  'archived-plant-loading': false,
  'archived-plant-total': 0,
  'archived-plant-FilteredCount': 0,

  //batch weight summary
  batchWeightSummary: null,
  //batch weight summary logs
  batchWeightSummaryLogs: [],
  'batchWeightSummary-loading': false,
  'batchWeightSummary-total': 0,
  'batchWeightSummary-FilteredCount': 0
}
